import React, { useState } from 'react';
import logoNav from '../../images/UNIQ_azul.png';

export const ConoceMasB = () => {
            return (
                <div className='conoceMas'>
                    <header className='headerConoceMas'>
                        <div className='nav'>
                            <img src={logoNav} alt="Uniq logo white" className="img" />
                        </div>
                        <div className='informacionConoceMas'>
                            <div className='textoConoceMas'>
                                <h1>Conoce como obtener tu <span>Cashback</span></h1>
                            </div>
                        </div>
                    </header>
                </div>
            );
};